<template>


  <!--begin: Form Body -->


 <div>
   <div class="tpl-box" :style="{  minHeight : height + 'px' }">

     <div class="overlay" v-if="fieldId "></div>


     <div id="tpl_content"></div>

     <V3right @update="updateField" @updateOption="updateOption" :option="option" :library="library"
              :field="tpl.field[fieldId]" v-if="fieldId " @closeEvent="fieldId=null"></V3right>




   </div>

     <!--   wap 按钮-->
     <div class="right-tool-mobile" v-if="client==='mobile'">
       <div class="right-tool-mobile-box" style="display: block">
         <div  @click="create" class="btn">保存合同模板
         </div>
       </div>
     </div>
     <!--    wap 按钮结束-->
     <!--   web 按钮-->
     <div class="right-tool" v-else>
       <div class="btn" style="margin-top: 15px;" @click="create">保存合同模板</div>
     </div>
     <!--    web 按钮结束-->

 </div>

</template>

<script>


import V3right from "@/components/field/v3right";
import LoadTemplate from "@/template/js/LoadTemplate";
import appClient from "@/conf/js/appClient";

export default {

  name: "create",
  /**
   * 接受消息
   */
  mounted() {
    if (this.client==='mobile')
      appClient.init()
  },
  data() {
    return {
      client : this.$route.query.client || 'mobile',
      rightShowLoading: false,
      id: this.$route.query.id,
      fieldId: null,
      height : 600,
      title: "上传模板",
      library: [],
      libraryConfig: [],
      option: {},
      tpl: {
        id: this.$route.query.id,
        css: "",
        html: "",
        content: [],
        version: "v3.1",
        name: "",
        file_id: "",
        field: []
      }
    };
  },

  components: {V3right},
  methods: {


    uploadTmp(e) {
      this.tpl.file_id = e.file_id;
      this.tpl.field = e.field;
    },

    read() {
      this.api.loading()
      this.api.post("/v1/V31Template/read", {id: this.tpl.id, event_type: "settings"}, (json) => {
        if (json.code === 200) {
          this.tpl = json.data
          LoadTemplate.html(this , 'settings')
          setTimeout(() => {
            this.api.hideLoading()
          }, 1200);
        } else  if (json.code === 402)  {
          setTimeout(()=>{
            this.read();
          }, 10000)
          this.api.alert(json.msg)
        } else {
          this.api.hideLoading()
          this.api.alert(json.msg)
        }
      })
    },
    /**
     * 获取组件库数据
     */
    getControlLibraryByV31() {
      this.api.post("/v1/Templates/getControlLibraryByV31", {id: this.tpl.id, event_type: "settings"}, (json) => {
        if (json.code === 200) {
          this.libraryConfig = [];
          this.library = [];
          json.data.forEach((item) => {
            this.library.push({
              name: item.name,
              value: item.id
            })
            this.libraryConfig[item.id] = item;
          })
        } else {
          this.api.alert(json.msg)
        }
      })
    },
    closeEvent() {

      if (this.fieldId  )
        this.fieldId = null
    },
    /**
     * 更新字段
     * @param e
     */
    updateField(e) {

      this.tpl.field[this.fieldId][e.field] = e.value;
      if (e.field === "type") {
        this.tpl.field[this.fieldId].type_name = e.name;
        this.tpl.field[this.fieldId].option = this.getFieldOption(e.value);
      }
    },

    /**
     * 更新配置项目
     * @param e
     */
    updateOption(e) {
      this.tpl.field[this.fieldId].option[e.field] = e.value;
    },
    /**
     * 获取默认的配置项
     * @param controlLibraryId
     * @returns {{date: string, radio_list_selected: number, display_radio: *, font_money: number, display_background_color: *, color: string, auto_sign_filler: string, doc_number_prefix: string, font_size: number, display_color: *, font_number: number, display_font_align: *, doc_number_suffix: string, display_font_underline: *, display_content_align_content: number, doc_number_length: number, checkbox_list: [{id: string, value: string}, {id: string, value: string}, {id: string, value: string}], font_interval: number, font_type: number, display_checkbox: *, display_font_interval: *, display_content_align: *, display_select_seal_value: string, display_font: *, display_select_seal: *, lock_ratio: *, checkbox_list_selected: *[], font_underline: number, background_color: number, display_date: *, display_number: *, font_align: string, display_doc_number: *, display_money: *, radio_list: [{id: string, value: string}, {id: string, value: string}, {id: string, value: string}]}}
     */
    getFieldOption(controlLibraryId) {

      let item = this.libraryConfig[controlLibraryId]
      return {
        display_font: item.display_font, //是否显示字体
        font_type: -1, //字体类型 -1默认
        font_size: -1, //字体大小 -1默认
        display_color: item.display_color,
        display_background_color: item.display_background_color,
        display_font_interval: item.display_font_interval,
        display_font_underline: item.display_font_underline,
        display_select_seal: item.display_select_seal,
        display_select_seal_value: "handwritten",
        display_font_align: item.display_font_align,
        font_align: "left",
        font_underline: -1,
        font_interval: -1,
        color: "#111111",
        background_color: -1,
        display_date: item.display_date,
        date: "YYYY/MM/DD",
        display_number: item.display_number,
        font_number: -1,
        display_money: item.display_money,
        font_money: -1,
        lock_ratio: item.lock_ratio,
        display_doc_number: item.display_doc_number,
        doc_number_length: 8,
        doc_number_prefix: "",
        doc_number_suffix: "",
        display_content_align: item.display_content_align,
        display_content_align_content: -1,
        display_radio: item.display_radio,
        auto_sign_filler: "请选择",
        radio_list: [
          {
            id: "",
            value: "单选选项1",
          },
          {
            id: "",
            value: "单选选项2",
          },
          {
            id: "",
            value: "单选选项3",
          }
        ],
        radio_list_selected: 0,
        display_checkbox: item.display_checkbox,
        checkbox_list: [
          {
            id: "",
            value: "多选选项1",
          },
          {
            id: "",
            value: "多选选项2",
          },
          {
            id: "",
            value: "多选选项3",
          }
        ],
        checkbox_list_selected: []
      }

    },

    getOption() {
      this.api.post("/v1/Templates/getOption", {}, (json) => {
        if (json.code === 200) {
          this.option = json.data
        } else {
          this.api.alert("获取配置文件失败，请重试")
        }

      })
    },
    /**
     * 更新模板
     */
    create() {
      this.api.loading()
      this.api.post("/v1/V31Template/V31settings", {
        id: this.tpl.id,
        field: this.tpl.field
      }, json => {
        if (json.code === 200) {
          this.api.alert("模板保存成功")
        } else
          this.api.alert(json.msg);

        this.api.hideLoading()
      });
    }


  },
  created() {

    this.height = document.documentElement.clientHeight
    this.read()
    this.getControlLibraryByV31()
    this.getOption()
  }
};
</script>
<style scoped>


.id-tpl-content img {
  max-width: 600px;
  width: 100%;
}

.id-tpl-content .loading-indicator {
  display: none;
}

</style>
